// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"53290675","453":"ef488a1c","710":"826adf2a"}[chunkId] + ".chunk.js";
};